import React from 'react';
import PropTypes from 'prop-types';

import { RideButton, RideFiConfettiLight } from '@rimac-seguros/ride-system-components';

import CustomModal from '../../../components/molecules/custom-modal';

import './styles.scss';

const ModalCurrentPolicy = ({
  isOpen, title, description, onClose, onConfirm,
}) => (
  <CustomModal
    isOpen={isOpen}
    iconClose
    overflow
    onClose={onClose}
    closeTypeRide
    classNameIcon="md:!col-start-3 md:!col-span-8 lg:!col-start-4 lg:!col-span-6"
  >
    <div className="modal-current-p">
      <RideFiConfettiLight size="x-large" />
      <h3>{title}</h3>
      <p>{description}</p>
      <RideButton text="De acuerdo" size="x-large" onClick={onConfirm} />
    </div>
  </CustomModal>
);

ModalCurrentPolicy.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
};

export default ModalCurrentPolicy;
